
import {
  defineComponent, ref, onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form, defineRule } from 'vee-validate';
import AppInput from '@/components/UI/AppInput.vue';
import AppButton from '@/components/UI/AppButton.vue';
import ValidationService from '@/services/ValidationService';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

defineRule('required', (value:string) => ValidationService.isNotEmpty(value) || 'This field is required');
defineRule('maxLength100', (value: string) => ValidationService.maxLength(value, 100) || 'Maximum length 100 characters');

export default defineComponent({
  components: {
    Form,
    AppInput,
    AppButton,
  },
  setup() {
    const schema = {
      nurseField: 'required|maxLength100',
    };

    const router = useRouter();
    const registrationStore = useRegistrationStore();

    const nurseFieldValue = ref(registrationStore.createUser.nurseField);

    function nextStep() {
      registrationStore.createUser.nurseField = nurseFieldValue.value;
      router.push('step-7');
    }

    onMounted(() => {
      if (!registrationStore.searchUser.firstName) {
        router.push('healthcare');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      schema,
      nurseFieldValue,
      nextStep,
    };
  },
});
